<script lang="ts">
  import type { ContainerProps } from "./types.ts";

  const {
    gap = "s",
    justify = "start",
    direction = "col",
    margin,
    mobileMargin,
    wrap = false,
    full = true,
    grow = false,
    outset = false,
    children,
  }: ContainerProps = $props();
</script>

<div
  class="flex"
  class:grow
  class:w-full={full}
  class:h-full={full}
  class:outset={outset === true}
  class:outset-m={outset === "m"}
  class:flex-wrap={wrap}
  class:flex-row={direction === "row"}
  class:flex-col={direction === "col"}
  class:justify-end={justify === "end"}
  class:justify-start={justify === "start"}
  class:justify-center={justify === "center"}
  class:text-center={justify === "center"}
  class:gap-2={gap === "s"}
  class:gap-5={gap === "m"}
  class:gap-10={gap === "l"}
  class:p-2={margin == "s"}
  class:p-4={margin == "m"}
  class:p-6={margin == "l"}
  class:max-mobile:p-0={mobileMargin == "none"}
  class:max-mobile:p-2={mobileMargin == "s"}
  class:max-mobile:p-4={mobileMargin == "m"}
  class:max-mobile:p-6={mobileMargin == "l"}
>
  {@render children?.()}
</div>
